import { List } from 'antd';

import { MobileDrawer } from '@Components/Base/MDrawer';
import { MInput, MButton, MSkeleton } from '@Components/Base/index';
import { User, UserReplacement } from '@Types/index';
import backgroundImg from '@Images/gradient-background.jpg';

import InfiniteScroll from 'react-infinite-scroll-component';
import EmployeeItem from './components/EmployeeItem';
import { MAX_LIMIT_SCROLL_LENGTH_USERS } from '../constants';

import styles from './employee-select.module.css';

interface EmployeesProps {
  users: User[] | UserReplacement[];
  onUserSelect: (user: User | UserReplacement) => void;
}

const Employees: React.FC<EmployeesProps> = ({ users, onUserSelect }) => {
  return (
    <List
      dataSource={users as User[]}
      itemLayout="vertical"
      renderItem={(user) => (
        <EmployeeItem
          key={user.empId || user.empNumber}
          user={user}
          onUserSelect={onUserSelect}
        />
      )}
    />
  );
};

interface MobileSearchEmployeeProps {
  users: User[] | UserReplacement[];
  onClose: () => void;
  onSearchChange: React.ChangeEventHandler<HTMLInputElement>;
  onUserSelect: (user: User | UserReplacement) => void;
  onLoadMore: (() => void) | undefined;
}

const DrawerContent: React.FC<MobileSearchEmployeeProps> = ({
  onClose,
  onSearchChange,
  onUserSelect,
  onLoadMore,
  users,
}) => {
  return (
    <div className={styles.content}>
      <div className={styles.inputSection}>
        <MInput
          searchInput
          onChange={onSearchChange}
          placeholder="Search by employee ID or employ..."
        />
        <MButton type="text" className={styles.cancelBtn} onClick={onClose}>
          Cancel
        </MButton>
      </div>
      <div id="scrollableReplacementList" className={styles.employeesWrapper}>
        <InfiniteScroll
          next={() => onLoadMore?.()}
          hasMore={users.length < MAX_LIMIT_SCROLL_LENGTH_USERS}
          loader={<MSkeleton paragraph={{ rows: 1 }} active />}
          dataLength={users.length}
          scrollableTarget="scrollableReplacementList"
        >
          <Employees onUserSelect={onUserSelect} users={users} />
        </InfiniteScroll>
      </div>
    </div>
  );
};

interface EmployeeSelectProps {
  isOpen: boolean;
  users: User[] | UserReplacement[];
  onSearchChange: React.ChangeEventHandler<HTMLInputElement>;
  onClose: () => void;
  onUserSelect: (user: User | UserReplacement) => void;
  onLoadMore: (() => void) | undefined;
}

const EmployeeSelect: React.FC<EmployeeSelectProps> = (props) => {
  const { isOpen, users, onSearchChange, onClose, onUserSelect, onLoadMore } =
    props;

  return (
    <MobileDrawer
      open={isOpen}
      rootClassName={styles.drawer}
      closable={false}
      style={{
        backgroundImage: `
        linear-gradient(222deg, rgba(227,237,247,1) 17%, rgba(227,237,247,0.4) 37%, rgba(227,237,247,0) 63%),
        linear-gradient(346deg, rgba(227,237,247,1) 17%, rgba(227,237,247,0.4) 37%, rgba(227,237,247,0) 63%),
        linear-gradient(90deg, rgba(227,237,247,0.5) 17%, rgba(227,237,247,0.4) 56%, rgba(227,237,247,0) 95%),
        url(${backgroundImg})
        `,
      }}
    >
      <DrawerContent
        users={users}
        onSearchChange={onSearchChange}
        onClose={onClose}
        onUserSelect={onUserSelect}
        onLoadMore={onLoadMore}
      />
    </MobileDrawer>
  );
};

export default EmployeeSelect;
